export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7527.2f2d12fc.jpg";